<template>
  <div class="social_list">
    <UTooltip :text="$t('social.share_x')">
      <NuxtLink v-if="showSocial(SocialList.X)" rel="nofollow" target="_blank" :to="getShareUrl(SocialList.X)">
        <DefaultIconsSocialX />
      </NuxtLink>
    </UTooltip>

    <UTooltip :text="$t('social.share_facebook')">
      <NuxtLink v-if="showSocial(SocialList.FACEBOOK)" rel="nofollow" target="_blank" :to="getShareUrl(SocialList.FACEBOOK)">
        <DefaultIconsSocialFacebook />
      </NuxtLink>
    </UTooltip>

    <UTooltip :text="$t('social.share_whatsapp')">
      <NuxtLink v-if="showSocial(SocialList.WHATSAPP)" rel="nofollow" target="_blank" :to="getShareUrl(SocialList.WHATSAPP)">
        <DefaultIconsWhatsapp />
      </NuxtLink>
    </UTooltip>

    <UTooltip :text="$t('social.share_copy')">
      <NuxtLink rel="nofollow" @click="copyUrlToClipboard">
        <DefaultIconsCopy />
      </NuxtLink>
    </UTooltip>
  </div>
</template>

<script setup lang="ts">
import {useSocialListConfig} from "~/composables/useSocialListConfig"
import {SocialList} from "~/libs/constants/SocialList"

const toast = useToast()
const {t} = useI18n()

const getSocialById = useSocialListConfig().getSocialById
const requestURL = useRequestURL()

const showSocial = (type: SocialList) => {
  return !!getSocialById(type)?.shareUrl
}

const getShareUrl = (type: SocialList) => {
  const url = getSocialById(type)?.shareUrl
  if (!url) {
    return
  }
  return `${url}${encodeURIComponent(requestURL.toString())}`
}

const copyUrlToClipboard = () => {
  navigator.clipboard.writeText(requestURL.toString())
  toast.add({ title: t('social.link_copied') })
}
</script>

<style lang="scss" scoped>
</style>